import React from "react"

import { joinClasses, useClasses } from "../globals";

import {
  Box,
  Collapse,
  Link,
  Typography
} from "@material-ui/core"
import { Alert } from "@material-ui/lab"


export const BadProject = () => {
  const classes = useClasses()

  const url = new URL(window.location.href);
  const isEnterpriseLink = url.hostname.indexOf("studio") < 0;
  const link = `${isEnterpriseLink ? `${window.location.origin}/portal/` : "https://portal.regis-co.com/"}${url.search}`;

  return (
    <React.Fragment>
      <Box
        className={joinClasses(
          classes._Padding,
          classes._Flex,
          classes._FlexDirectionColumn
        )}
      >
        <Box className={classes._Margin}>
          <Collapse in>
            <Alert severity="error">
              <Typography>
                The project you are looking for could not be found or you do not have access to it.
              </Typography>
              <br/>
              <Link href={link}>Return to Portal</Link>
            </Alert>
          </Collapse>
        </Box>
      </Box>
    </React.Fragment>
  )
}

BadProject.title = "Not Found";